<template>
  <div
    id="inbox"
    class="no-shrink">
    <InboxNavigator/>
    <OrganizationTree/>
  </div>
</template>

<style lang="scss">
#inbox {
  width: 258px;
  background-color: $greyUltralight;
  box-shadow: 1px 0 $borderGray;
  z-index: 1000;
}
</style>

<script>
import InboxNavigator from '../InboxNavigator';
import OrganizationTree from '../OrganizationTree';

export default {
  name: 'Inbox',
  components: {
    InboxNavigator,
    OrganizationTree,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
